import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M19.625 16.094a8.4 8.4 0 0 0 1.156 1.687c.219.219.25.532.157.782a.71.71 0 0 1-.657.437c-1.687 0-3.031-.625-3.937-1.187A9 9 0 0 1 14.5 18c-2.719 0-5-1.25-6-3.031-.281-.063-.594-.094-.875-.156-.906.562-2.25 1.218-3.906 1.218a.77.77 0 0 1-.688-.437c-.094-.281-.031-.594.156-.781 0-.032.688-.782 1.188-1.72C3.5 12.22 3 11.157 3 10c0-2.75 2.906-5 6.5-5 2.688 0 5 1.281 5.969 3.094C18.594 8.438 21 10.5 21 13c0 1.188-.531 2.25-1.375 3.094M7.344 13.187l.625.157c.5.125 1 .156 1.531.156 2.688 0 5-1.594 5-3.5 0-1.875-2.312-3.5-5-3.5-2.719 0-5 1.625-5 3.5 0 .906.5 1.594.906 2l.782.781-.47.969a3.4 3.4 0 0 0-.25.469 5.5 5.5 0 0 0 1.345-.688zM18.562 15c.407-.406.938-1.094.938-2 0-1.531-1.531-2.844-3.531-3.312 0 .124.031.218.031.312 0 2.531-2.437 4.625-5.625 4.969.906.906 2.438 1.531 4.125 1.531.5 0 1.031-.031 1.531-.156l.594-.157.563.344c.437.282.875.532 1.343.688-.093-.157-.187-.313-.25-.469l-.5-.969z"
    />
  </svg>
);
export default SvgBlog;
